import { hasPermission } from './permissions';

type Permissions = Parameters<typeof hasPermission>[0];

export const canManageInvoiceReferences = (permissions: Permissions) => (
  hasPermission(permissions, 'invoices.reference.manage')
  || (hasPermission(permissions, 'consultant') && hasPermission(permissions, 'cases.manage'))
);

export const canManageCaseDates = (permissions: Permissions) => (
  hasPermission(permissions, 'cases.dates.manage') && !hasPermission(permissions, 'klantmanager')
);

export const hasAdministrationOnlyAccess = (permissions: Permissions) => (
  (hasPermission(permissions, 'invoices.reference.manage') || canManageCaseDates(permissions))
  && !hasPermission(permissions, 'cases.read')
  && !hasPermission(permissions, 'cases.manage')
);
